import { View } from "@baseline/ui/views";


export let views =
{
    landingPage: View.create()
};
